import { Navbar } from "@/components/Navbar";
import { Footer } from "@/components/Footer";
import { Contact } from "@/components/Contact";
import { usePageMeta } from "@/hooks/usePageMeta";

export default function ContactPage() {
  usePageMeta({
    title: "Contact | BrandZenith",
    description:
      "Tell us your next move. Start a project with BrandZenith — we respond to every enquiry personally within one business day.",
    path: "/contact",
  });

  return (
    <>
      <Navbar />
      <main className="pt-16">
        <Contact />
      </main>
      <Footer />
    </>
  );
}
